import { CreateVitalsResponse, CreateObservationRequest } from '@quromedical/models';
import { trpc } from 'trpc';

export class ObservationApi {
  public async createObservationVital(
    params: CreateObservationRequest
  ): Promise<CreateVitalsResponse> {
    return await trpc.client.patient.createObservation.mutate({
      ...params,
    });
  }
}
